export default __webpack_public_path__ + "static/media/vayuda_turquoise_chunk.09dac20d.png";